import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Navitems } from './Models/navitems.model';
import { UserInfoComponent } from '../user-info/user-info.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AuthHelperService } from 'src/app/services/auth-helper.service';
import { StateService } from 'src/app/services/state.service';

@Component({
    selector: 'app-topheader',
    templateUrl: './topheader.component.html',
    styleUrls: ['./topheader.component.scss'],
    standalone: false
})
export class TopheaderComponent implements OnInit {

  url: string;
  reportNavItems: Navitems[];
  appNavItems: Navitems[];
  roleBasedReportsData: Navitems[];
  modalRef: BsModalRef;
  currentUser: string;
  state$: string;


  constructor(private router: Router,
    private modalService: BsModalService,
    private authService: AuthService,
    private appInsights: AppInsightsService,
    private stateService: StateService,
    private authHelperService: AuthHelperService,
  ) {
    this.url = router.url;
    this.appInsights.logEvent("Top-Header:" + this.url);
     this.currentUser= this.authService.getUserName();
    this.stateService.setState("userName",this.currentUser);
    this.state$ = this.stateService.getState('userName');
  }

  ngOnInit() {
    }

  changeClass(id: any) {
    (<HTMLElement>document.getElementById(id)).className = "nav-link mb-2 active";
    this.router.navigate(['reports/favorites']);
  }

  userinfo() {
    this.modalRef = this.modalService.show(UserInfoComponent, { class: 'modal-dialog-sm' });
  }

  // logout() {
  //   this.authService.logout();
  // }

  logout() {
    this.authHelperService.logout();
  }

}